// extracted by mini-css-extract-plugin
module.exports = {"MenuItem":"pa_a pz_rf pz_cv pz_a","MenuItem__Btn":"pa_b pz_z"};